import { render, staticRenderFns } from "./Res3.vue?vue&type=template&id=c7a73674&scoped=true&lang=pug"
import script from "./Res3.vue?vue&type=script&lang=js"
export * from "./Res3.vue?vue&type=script&lang=js"
import style0 from "./Res3.vue?vue&type=style&index=0&id=c7a73674&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a73674",
  null
  
)

export default component.exports